import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Sparkles } from "lucide-react";

export default function DashboardNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="border-b border-bone-200 bg-white">
      <div className="max-w-[1600px] mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="brand-link">
          <Sparkles size={20} strokeWidth={1.5} className="text-forest-600" />
          <span className="font-heading text-xl text-forest-700">Toothpix</span>
          <span className="overline ml-2 hidden md:inline">AI Smile Preview</span>
        </Link>
        <div className="flex items-center gap-1 md:gap-2">
          <NavLink
            to="/dashboard"
            end
            data-testid="nav-leads"
            className={({ isActive }) =>
              `px-4 py-2 text-sm transition-colors ${
                isActive ? "text-forest-600 font-medium" : "text-forest-400 hover:text-forest-600"
              }`
            }
          >
            Leads
          </NavLink>
          <NavLink
            to="/dashboard/settings"
            data-testid="nav-settings"
            className={({ isActive }) =>
              `px-4 py-2 text-sm transition-colors ${
                isActive ? "text-forest-600 font-medium" : "text-forest-400 hover:text-forest-600"
              }`
            }
          >
            Clinic
          </NavLink>
          {user?.is_super_admin && (
            <NavLink
              to="/admin"
              data-testid="nav-admin"
              className="px-3 py-1 text-xs uppercase tracking-[0.18em] bg-forest-600 text-white hover:bg-forest-500 ml-2"
            >
              Admin
            </NavLink>
          )}
          <div className="hidden md:block text-xs text-forest-400 px-3 border-l border-bone-200 ml-2">
            {user?.clinic_name}
          </div>
          <button
            data-testid="logout-btn"
            onClick={() => {
              logout();
              navigate("/");
            }}
            className="ml-2 p-2 text-forest-400 hover:text-forest-700 transition-colors"
            aria-label="Logout"
          >
            <LogOut size={18} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </nav>
  );
}
